import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.fehlerbild-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFehlerbildHinzufuegenEffects {

    FehlerbildHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FEHLERBILD_HINZUFUEGEN),
        mergeMap((x: ac.PostFehlerbildHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFehlerbildHinzufuegen(x.aufgabeBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostFehlerbildHinzufuegenErfolgreichAction(x.aufgabeBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFehlerbildHinzufuegenFehlerAction(error, x.aufgabeBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FehlerCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FehlerCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FehlerCommandService);
        }
        return this.service;
    }
}
